import script from "./SalesListsDetailsView.vue?vue&type=script&setup=true&lang=js"
export * from "./SalesListsDetailsView.vue?vue&type=script&setup=true&lang=js"

import "./SalesListsDetailsView.vue?vue&type=style&index=0&id=2d913484&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d913484"]])

export default __exports__